import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, CardTitle, Table } from 'reactstrap'
import "./aboutSurvay.css"

const AboutSurvey = () => {
    return (
        <div className="content">
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col className="text-right" sm="6">
                                    <CardTitle tag="h5"><i className="tim-icons icon-bulb-63 text-info" /> درباره سامانه</CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="text-right">
                            <p></p>
                            <p className="text-justify">
                                سامانه سراج امکان دسترسی سیاست‌ گذاران، برنامه ریزان و پژوهشگران فعال در زمینۀ آسیب های اجتماعی را به اطلاعات علمی دقیق و به‌روز در این حوزه فراهم کرده است.
                            </p>
                            <p className="text-justify">
                                داشبورد حاضر با عنوان «داشبورد مدیریتی رصد آسیب های اجتماعی ایران و عوامل تعیین کنندۀ آنها در سال های 1397 تا 1400» حاصل پیمایش هایی است که در این سال ها توسط سازمان بهزیستی کشور با هدف بررسی میزان شیوع آسیب های اجتماعی (شامل اعتیاد، روابط غیر ازدواجی، همسر آزاری، روسپیگری، دریافت رشوه، پیشنهاد رشوه و ادراک فساد) و همچنین شناسایی تعیین‌ کننده‌های این آسیب ها (شامل سلامت روانی، صفات ضداجتماعی، دین داری، رضایت زناشویی، حمایت خانوادگی، سلامت اجتماعی و احساس نابرابری) در میان شهروندان 15 تا 60 ساله ایرانی انجام گرفته است.
                            </p>
                            <p className="text-justify">
                                این داشبورد می تواند دسترسی سیاست گذاران، برنامه ریزان و پژوهشگران فعال در زمینۀ مطالعۀ آسیب های اجتماعی را به اطلاعات علمی دقیق و به‌روز در این حوزه تسهیل کند. برای دستیابی به این هدف، در این داشبورد میزان گستردگی آسیب های اجتماعی و تعیین کننده های آن ها در دو سطح کشوری و استانی در قالب نمودارهای مختلف به تصویر کشیده شده است.
                            </p>
                            <p>&nbsp;</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col className="text-right" sm="6">
                                    <CardTitle tag="h5"><i className="tim-icons icon-sound-wave text-info" /> موج اول</CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="text-right">
                            <p></p>
                            <p className="text-justify">
                                موج اول پیمایش رصد آسیب های اجتماعی ایران و عوامل تعیین کننده در سال های  1398-1397 با تعداد نمونه 125756 نفربه روش پیمایش مقطعی با روش نمونه گیری سهمیه ای (متناسب با ترکیب سنی و جنسی) در 31 استان کشور شامل 93 شهر و 279 روستا انجام شده است. بدین منظور از هر استان علاوه بر شهر مرکز استان، یک شهرستان کم آسیب و یک شهرستان پرآسیب بر اساس آمارهای موجود استانی و نظرات کارشناسان حوزه آسیب های اجتماعی و از هر شهر سه روستا (بر اساس پراکندگی جغرافیایی) انتخاب شده و جمع آوری اطلاعات در آن ها انجام گرفت.
                            </p>
                            <p>&nbsp;</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col className="text-right" sm="6">
                                    <CardTitle tag="h5"><i className="tim-icons icon-sound-wave text-info" /> موج دوم</CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="text-right">
                            <p></p>
                            <p className="text-justify">
                                موج دوم پیمایش رصد آسیب های اجتماعی ایران و عوامل تعیین کننده در سال های  1399-1398 با تعداد 59986 نفر به روش پیمایشی مقطعی با روش نمونه گیری سهمیه ای (متناسب با ترکیب سنی و جنسی) در 30 استان کشور شامل 90 شهر انجام شده است. بدین منظور از هر استان علاوه بر شهر مرکز استان یک شهرستان کم آسیب و یک شهرستان پرآسیب، بر اساس آمارهای موجود استانی و نظرات کارشناسان حوزه آسیب های اجتماعی انتخاب شده و جمع آوری اطلاعات در آن ها انجام گرفت.
                            </p>
                            <p className="text-justify">
                                لازم به ذکر است که در این موج داده های معتبری از استان قزوین به دست نیامد و این موج فاقد اطلاعات استان قزوین است.
                            </p>
                            <p>&nbsp;</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col className="text-right" sm="6">
                                    <CardTitle tag="h5"><i className="tim-icons icon-sound-wave text-info" /> موج سوم</CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="text-right">
                            <p></p>
                            <p className="text-justify">
                            موج سوم پیمایش رصد آسیب های اجتماعی ایران و عوامل تعیین کننده در سال های 1400-1399، با حجم نمونه 34100 نفر و با بهره گیری از همکاری و تخصص گروه های مختلف شرکت نقش کلیک از جمله گروه اجتماعی (در بخش طراحی و تحلیل) و همچنین حضور بیش از 200 نفر از سرپرستان و پرسشگران کارآزموده این شرکت (در بخش جمع آوری داده) در حال انجام است. همانند پیمایش های قبلی، در این موج از پیمایش نیز از روش نمونه گیری سهمیه ای متناسب با ترکیب سنی و جنسی استفاده خواهد شد. این موج در 31 استان و 91 شهر در سراسر کشور (شامل مرکز هر استان، یک شهرستان کم آسیب و یک شهرستان پرآسیب آن استان که بر اساس آمارهای موجود استانی و نظرات کارشناسان حوزه آسیب های اجتماعی انتخاب شده اند) به اجرا در آمد.
                            </p>
                            <p>&nbsp;</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col className="text-right" sm="6">
                                    <CardTitle tag="h5"><i className="tim-icons icon-zoom-split text-info" /> شاخص ها، مولفه ها و گویه ها</CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="text-right">
                            <p></p>
                            <p>آسیب ها</p>
                            <p>
                                <ul>
                                    <li>اعتیاد</li>
                                    <li>روابط غیرازدواجی</li>
                                    <li>همسرآزاری</li>
                                    <li>روسپیگری</li>
                                    <li>دریافت رشوه</li>
                                    <li>پرداخت رشوه</li>
                                    <li>پیشنهاد رشوه</li>
                                    <li>ادراک فساد</li>
                                </ul>
                            </p>
                            <p>&nbsp;</p>
                            <p>تعیین کننده ها</p>
                            <p>
                                <ul>
                                    <li>سلامت روانی</li>
                                    <li>صفات ضداجتماعی</li>
                                    <li>دین داری</li>
                                    <li>رضایت زناشویی</li>
                                    <li>حمایت خانوادگی</li>
                                    <li>سلامت اجتماعی</li>
                                    <li>احساس نابرابری اجتماعی</li>
                                </ul>
                            </p>
                            <p>&nbsp;</p>
                            <Table>
                                <thead>
                                    <th width="15%">شاخص</th>
                                    <th width="15%">مولفه</th>
                                    <th width="70%">گویه</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowSpan="6" className="white-background">صفات ضداجتماعی</td>
                                        <td>بدخواهی</td>
                                        <td>
                                            9. برایم اصلا مهم نیست که باعث آزار دیگران شوم.<br />
                                            10. ماجراهایی تعریف میکنم که به کلی دروغ است.<br />
                                            15. مشکلات دیگران برایم مهم نیست.<br />
                                            16. خوشم می آید کاری کنم که زیر دستانم احمق به نظر برسند.<br />
                                            18. به راحتی می توانم دیگران را گول بزنم.<br />
                                            19. برای دستیابی به خواسته ام، از دیگران سوء استفاده می کنم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>بی برنامه گی</td>
                                        <td>
                                            2. بعضی کارها را بدون فکر کردن انجام می دهم<br />
                                            3. در مورد مسائل مختلف به دقت فکر می کنم «نمره گذاری معکوس»<br />
                                            6. برای آینده برنامه ریزی می کنم (به فکر آینده هستم) «نمره گذاری معکوس»<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>حواس پرتی</td>
                                        <td>
                                            13. به آسانی حواسم پرت میشود.<br />
                                            17. از بس که چیزهای دیگر حواسم پرت می کنند، ....<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>تصمیم گیری تکانشی</td>
                                        <td>
                                            21. سریع تصمیم می گیرم<br />
                                            4. به فکر حفظ شغل خود هستم. «نمره گذاری معکوس»<br />
                                            5. بدون فکر قبلی و در لحظه عمل می کنم<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>قانون گریزی</td>
                                        <td>
                                            7. در مجموع آدم هایی که قانون را رعایت نمی کنند،موفق ترند.<br />
                                            11. به تجربه فهمیده ام هر گاه قانون را رعایت نمی کنم، کارها راحت تر انجام می شوند.<br />
                                            12. اگر تقلب باعث پیشبرد کارم شود، در انجام آن تردید به خودم راه نمی دهم.<br />
                                            19. برای دستیابی به خواسته ام، از دیگران سوء استفاده می کنم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>خطرجویی</td>
                                        <td>
                                            8. انجام کارهای خطرناک را دوست دارم.<br />
                                            14. وقتی دارم کار خطرناکی می کنم، به این فکر نمی کنم که ممکن است صدمه ببینم.<br />
                                            20. کارهای زیادی می کنم که از نظر دیگران خطرناک است.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">سلامت روان</td>
                                        <td></td>
                                        <td>
                                            140. توانایی تمرکزم ...<br />
                                            141. بی خوابی به خاطر نگرانی زیاد ...<br />
                                            142. نقش مفید ...<br />
                                            143. توانایی ام برای گرفتن تصمیم...<br />
                                            144. احساس تحت فشار بودن....<br />
                                            145. ناتوانی از غلبه بر سختی ها...<br />
                                            146. لذت بردنم از فعالیتهای روزانه زندگی...<br />
                                            147. توانایی ام برای روبرو شدن با مشکلات...<br />
                                            148. احساس شاد نبودن و غمگین بودن...<br />
                                            149. احساس از دست دادن اعتماد به نفس...<br />
                                            150. خود را بی ارزش دانستن...<br />
                                            151. احساس خوشحالی ام (خوشحالی در حد معمول )....<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">رضایت زناشویی</td>
                                        <td></td>
                                        <td>
                                            21. برای تمام کردن بحث زود تسلیم می شوم.<br />
                                            22. همسرم و من همدیگر را کاملا درک می کنیم.<br />
                                            23. از نحوه گفتگو کردن مان ناخشنودم.<br />
                                            24. همسرم مرا کاملا درک می کند و با هر خلق من همدردی می کند.<br />
                                            25. موقعی که در مورد مشکلاتمان بحث می کنیم، همسرم  مرا درک می کند.<br />
                                            26. هرگز از رابطه با همسر خود پشیمان نشده ام.<br />
                                            27. از نحوه انجام سرگرمی ها و فعالیتهای مشترکمان راضی ام.<br />
                                            28. همسرم شنونده خیلی خوبی است.<br />
                                            29. از چگونگی حرف زدن مان با هم بسیار راضی ام.<br />
                                            30. هنگام جر و بحث برای جلوگیری از جریحه دار شدن احساسات همسرم سکوت می کنم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowSpan="5" className="white-background">همسرآزاری</td>
                                        <td>جسمی سبک</td>
                                        <td>
                                            32. سیلی زدن یا کتک زدن شما<br />
                                            34. پیچاندن مو یا مچ دست شما<br />
                                            36. گرفتن و بستن دست و پای شما<br />
                                            42. هل دادن شما<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>جسمی سنگین</td>
                                        <td>
                                            37. سوزاندن شما با اجسام داغ<br />
                                            38. زخمی کردن شما با چاقو یا اسلحه<br />
                                            39. کتک زدن به شدتی که نیاز به پزشک و درمان پیدا کنید<br />
                                            40. پرتاب اشیاء به سمت شما<br />
                                            43. فشار دادن گلوی شما<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>عاطفی</td>
                                        <td>
                                            31. بی اعتنایی و بی توجهی به سخنان و نظرات شما (مثلا در تصمیم گیری ها)<br />
                                            33. بی اعتنایی و بی توجهی به درخواستها، نیازها، یا محدودیت های مالی شما<br />
                                            35. توجه بیش از حد به افراد دیگر در حضور شما<br />
                                            41. بی اعتنایی و بی توجهی به درد، غم، اضطراب و سایر نیازهای غیرمالی شما<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>کلامی</td>
                                        <td>
                                            44. نیش و کنایه یا زخم زبان زدن<br />
                                            45. فحش دادن<br />
                                            46. تهمت زدن یا متهم کردن به رفتارهای ناپسند<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>جنسی</td>
                                        <td>
                                            47. برقراری رابطه جنسی در زمانی که شما تمایلی ندارید.<br />
                                            48. برقراری رابطه جنسی به شکلی یا از راهی که شما رضایت ندارید.<br />
                                            49. برقراری رابطه جنسی همراه با خشونت<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">ادراک فساد</td>
                                        <td></td>
                                        <td>
                                            81. احزاب و سازمان های سیاسی.<br />
                                            82. خیریه ها، انجمنها و دیگر سازمان های غیردولتی.<br />
                                            83. درمانگاهها، بیمارستانها، مطب های پزشکان، آزمایشگاهها، و دیگر مراکز سلامت.<br />
                                            84. ادارات ثبت اسناد و احوال.<br />
                                            85. شهرداری ها.<br />
                                            86. ادارات دارایی (مالیات).<br />
                                            87. ادارات گمرک<br />
                                            88. کلانتری ها و ادارات آگاهی.<br />
                                            89. ماموران راهنمایی و رانندگی.<br />
                                            90. دادسراها و دادگاه ها.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowSpan="2" className="white-background">وضعیت دینداری</td>
                                        <td>اخلاقی اجتماعی</td>
                                        <td>
                                            50. دروغ گفتن به دوستی که سرقرار ملاقات با او نتوانسته اید به موقع حاضر شوید.<br />
                                            51. پس ندادن چیزی که از دوستی امانت گرفته اید.<br />
                                            52. مشاجره و تندی با پدر و مادر.<br />
                                            53. نپرداختن مزد به کسی، به همان مقداری که با او قرار گذاشته بودید.<br />
                                            54. نپرداختن بدهی یا اجاره منزل، در حالی که توانایی پرداخت آن را داشته اید.<br />
                                            55. کم فروشی یا کم کاری عمدی (در انجام وظیفه).<br />
                                            56. کلک زدن و فریب دادن دیگران برای دستیابی به سود بیشتر یا موقعیت بهتر<br />
                                            57. ناراحت شدن با دیدن صفتی مثل زیبایی، موقعیت اجتماعی، یا ثروت در دیگران<br />
                                            58. ریختن زباله در خیابان یا دامان طبیعت<br />
                                            59. تشویق دیگران به انجام کار خوب یا بازداشتن آنها از کار بد در صورت امکان.<br />
                                            60. خواندن نمازهای پنجگانه روزانه<br />
                                            61. گرفتن روزه در ماه مبارک رمضان<br />
                                            62. شرکت در نماز جماعت<br />
                                            63. خواندن قرآن و دعاهای دینی<br />
                                            64. نوشیدن مشروبات الکلی<br />
                                            65. رابطه جنسی خارج از قواعد دینی.<br />
                                            66. پرداخت بخشی از درآمد یا دارایی خود برای رفع نیاز دیگران (خمس، زکات).<br />
                                            67. برای کسی که توانایی مالی و بدنی دارد، حجّ خانه خدا واجب است.<br />
                                            68. رعایت حجاب (پوشاندن بدن به جز صورت و دست ها تا مچ) برای زن ها واجب است.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>عبادی معنوی</td>
                                        <td>
                                            69. کلا خود را چقدر به خدا نزدیک احساس می کنید؟<br />
                                            70. وجود خدا را در زندگی روزمره تان چقدر احساس می کنید؟<br />
                                            71. در انجام امور مهم زندگی چقدر به خدا توکل می کنید؟<br />
                                            72. چقدر از خدا می خواهید که در زندگی به شما کمک کند؟<br />
                                            73. معمولا چقدر نذر می کنید؟<br />
                                            74. چقدر احساس می کنید که خدا نذرها و دعاهای شما را برآورده می کند؟<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">احساس نابرابری اجتماعی</td>
                                        <td></td>
                                        <td>
                                            75. در کل کشور<br />
                                            76. در شهر شما<br />
                                            77. در محله شما<br />
                                            78. در محیط کار یا تحصیل شما<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowSpan="5" className="white-background">سلامت اجتماعی</td>
                                        <td>اعتماد سیاسی</td>
                                        <td>
                                            102. به دادگاه ها و دادسراها و .. اعتماد دارم.<br />
                                            104. معمولا در انتخابات ریاست جمهوری شرکت می کنم.<br />
                                            105. معمولا در انتخابات مجلس شرکت می کنم.<br />
                                            106. معمولا در انتخابات شوراهای شهر و روستا شرکت می کنم.<br />
                                            118. به نهادهای نظامی و امنیتی اعتماد دارم.<br />
                                            130. به صدا و سیما اعتماد دارم.<br />
                                            131. به دولت اعتماد دارم.<br />
                                            132. به شهرداری ها و شوراها اعتماد دارم.<br />
                                            133. به مجلس شورای اسلامی اعتماد دارم.<br />
                                            135. به مراکز درمانی اعتماد دارم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>مسئولیت پذیری اجتماعی</td>
                                        <td>
                                            103. سعی میکنم با نهادهای غیردولتی (مانند انجمن اولیا و مربیان، انجمن اسلامی، انجمن های ادبی، هیات های مذهبی، جلسات قرآن) همکاری کنم.<br />
                                            115. در حفظ محیط زیست در خارج از خانه ام کوشا هستم.<br />
                                            116. به قوانین جامعه مانند قوانین راهنمایی و رانندگی احترام می گذارم.<br />
                                            117. به سنت ها و رسوم اجتماعی احترام می گذارم.<br />
                                            118. به نهادهای نظامی و امنیتی اعتماد دارم.<br />
                                            119. وظایف شغلی ام را به خوبی انجام می دهم.<br />
                                            120. در کل فکر می کنم فرد مفیدی برای جامعه هستم.<br />
                                            121. برای رسیدن به اهداف شخصی ام حاضر نیستم به مردم ضرر بزنم.<br />
                                            122. اگر یکی از اعضای جامعه احتیاج زیادی به کمک مالی داشته باشد، به او کمک می کنم.<br />
                                            123. به سالمندان یا معلولان کمک می کنم.<br />
                                            124. برای رسیدن به اهداف شخصی ام، حاضرم به دوستان همسایگان و همکارانم ضرر بزنم. (نمره گذاری معکوس)<br />
                                            134. در محیط زندگی به حقوق مردم توجه دارم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>مشارکت اجتماعی</td>
                                        <td>
                                            107. در فعالیت های محله (گردهمایی ها، جشن ها و سوگواری ها) شرکت می کنم.<br />
                                            126. در تصمیمات خانواده ام مشارکت فعال دارم.<br />
                                            138. با اعضای جامعه برای رسیدن به اهداف و خواسته های مشترکمان همکاری میکنم.<br />
                                            108. با سایر افراد اجتماع احساس نزدیکی و دوستی  می کنم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>احساس حمایت اجتماعی</td>
                                        <td>
                                            100. در جامعه خود احساس امنیت و آرامش می کنم.<br />
                                            109. در زمان بیماری به خدمات پزشکی مناسب دسترسی دارم.<br />
                                            110. در جامعه شرایطی هست که باعث شده من سالم باشم و بیمار نشوم.<br />
                                            111. در زمان مشکل مالی، سازمانی هست که به من کمک کند.<br />
                                            112. جامعه امکان رشد و پیشرفت را برایم فراهم می سازد.<br />
                                            114. در محله ام احساس امنیت و آرامش می کنم.<br />
                                            125. در محیط خانه ام احساس امنیت و آرامش می کنم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>اعتماد اجتماعی</td>
                                        <td>
                                            99. مردم غالبا راستگویند.<br />
                                            101. مردم غالبا انصاف دارند.<br />
                                            108. با سایر افراد اجتماع احساس نزدیکی و دوستی  می کنم.<br />
                                            113. مردم غالبا به قول و قرارهای خود عمل می کنند.<br />
                                            114. در محله ام احساس امنیت و آرامش می کنم.<br />
                                            127. به افراد و اعضای جامعه اعتماد دارم.<br />
                                            128. به همسایگان و اهالی محل اعتماد دارم.<br />
                                            129. مردم غالبا امانتدارند.<br />
                                            135. به مراکز درمانی اعتماد دارم.<br />
                                            136. به انجمن های مردمی و موسسات خیریه اعتماد دارم.<br />
                                            137. به نهادهای دینی مانند مساجد، روحانیت، هیات های مذهبی اعتماد دارم.<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">رشوه </td>
                                        <td></td>
                                        <td>
                                            91. در طول سال گذشته برای آنکه کاری خلاف قانون یا مقررات برایتان انجام شود یا کارتان سریعتر انجام شود، آیا خود شما به فردی در سازمان های اداری (دولتی، خصوصی، عمومی) هزینه اضافی به صورت نقدی یا غیرنقدی پرداخت کرده اید؟<br />
                                            92. آیا در طول سال گذشته برای شما پیش آمده است که فردی با پرداخت هزینه اضافی به صورت نقدی یا غیر نقدی خارج از روال اداری، از شما بخواهد که کاری خلاف قانون یا مقررات برایش انجام دهید یا کارش را سریعتر انجام دهید؟<br />
                                            93. در صورت پاسخ بله به سوال فوق، آیا تا به حال درخواست آنها را برآورده کرده اید؟<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">مصرف مواد</td>
                                        <td></td>
                                        <td>
                                            79. کدام یک از مواد زیر را حداقل یک بار در عمرتان مصرف کرده اید؟ «شامل 19 گروه از مواد مختلف»<br />
                                            80. در سال گذشته کدام یک از مواد زیر را هر روز یا تقریبا هر روز مصرف کرده اید؟ «شامل 19 گروه از مواد مختلف»<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">روابط جنسی نامتعارف</td>
                                        <td></td>
                                        <td>
                                            94. در یک سال گذشته کدام یک از انواع رابطه های زیر را با فردی غیر از همسر داشته اید؟<br />
                                            95. آیا برای انجام این رابطه پول یا کمک غیرنقدی هم دریافت کردید؟<br />
                                            96. آیا شما این رابطه را با هدف کسب پول یا کمک غیرنقدی انجام دادید؟<br />
                                            97. پول یا کمک غیرنقدی ای که از این رابطه به دست می آورید، چقدر از درآمد معمول شما را تشکیل می دهد؟<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="white-background">حمایت خانوادگی</td>
                                        <td></td>
                                        <td>
                                            152. خانواده ام مایل اند در تصمیم گیری ها به من کمک کنند.<br />
                                            153. خانواده ای دارم که می توانم غم ها و شادی هایم را با آنها قسمت کنم.<br />
                                            154. به اندازه مورد نیاز از خانواده ام حمایت و کمک دریافت می کنم.<br />
                                            155. می توانم راجع به مشکلاتم با خانواده ام صحبت کنم.<br />
                                            156. اگر به مشکلی برخورد کنم، خانواده درجه اول (برادر، خواهر، والدین، یا فرزندان) به من کمک مالی خواهند کرد.<br />
                                            157. اگر به مشکلی برخورد کنم، خانواده درجه اول (برادر، خواهر، والدین، یا فرزندان) به من کمک غیرمالی خواهند کرد.<br />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <p>&nbsp;</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col className="text-right" sm="6">
                                    <CardTitle tag="h5"><i className="tim-icons icon-sound-wave text-info" />91 شهر شرکت کننده در پیمایش</CardTitle>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="text-right">
                            <p></p>
                            <table className="participants">
                                <thead>
                                    <tr>
                                        <td rowspan="2" >
                                            <p><strong>ردیف</strong></p>
                                        </td>
                                        <td rowspan="2" >
                                            <p><strong>استان</strong></p>
                                        </td>
                                        <td rowspan="2" >
                                            <p><strong>شهر</strong></p>
                                        </td>
                                        <td colspan="3" >
                                            <p><strong>تعداد شرکت کنندگان در هر استان</strong></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p><strong>1400</strong></p>
                                        </td>
                                        <td >
                                            <p><strong>1398</strong></p>
                                        </td>
                                        <td >
                                            <p><strong>1397</strong></p>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td >
                                            <p>1</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>اردبيل</p>
                                        </td>
                                        <td >
                                            <p>اردبيل</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1102</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1998</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4073</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>2</p>
                                        </td>
                                        <td >
                                            <p>پارس آباد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>3</p>
                                        </td>
                                        <td >
                                            <p>سرعين</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>4</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>اصفهان</p>
                                        </td>
                                        <td >
                                            <p>اصفهان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1100</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1999</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4036</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>5</p>
                                        </td>
                                        <td >
                                            <p>کاشان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>6</p>
                                        </td>
                                        <td >
                                            <p>مبارکه</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>7</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>البرز</p>
                                        </td>
                                        <td >
                                            <p>کرج</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1116</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2001</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4090</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>8</p>
                                        </td>
                                        <td >
                                            <p>اشتهارد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>9</p>
                                        </td>
                                        <td >
                                            <p>فرديس</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>10</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>ايلام</p>
                                        </td>
                                        <td >
                                            <p>ايلام</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1112</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2000</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4096</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>11</p>
                                        </td>
                                        <td >
                                            <p>دهلران</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>12</p>
                                        </td>
                                        <td >
                                            <p>ايوان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>13</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>آذربايجان شرقي</p>
                                        </td>
                                        <td >
                                            <p>اهر</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1100</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2017</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4059</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>14</p>
                                        </td>
                                        <td >
                                            <p>تبريز</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>15</p>
                                        </td>
                                        <td >
                                            <p>مرند</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>16</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>آذربايجان غربي</p>
                                        </td>
                                        <td >
                                            <p>اروميه</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1145</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2009</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4100</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>17</p>
                                        </td>
                                        <td >
                                            <p>خوئ</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>18</p>
                                        </td>
                                        <td >
                                            <p>شاهين دژ</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>19</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>بوشهر</p>
                                        </td>
                                        <td >
                                            <p>بوشهر</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1103</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1998</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4040</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>20</p>
                                        </td>
                                        <td >
                                            <p>تنگستان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>21</p>
                                        </td>
                                        <td >
                                            <p>گناوه</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>22</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>تهران</p>
                                        </td>
                                        <td >
                                            <p>تهران</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1145</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2003</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4067</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>23</p>
                                        </td>
                                        <td >
                                            <p>قدس</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>24</p>
                                        </td>
                                        <td >
                                            <p>رئ</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>25</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>چهارمحال بختياری</p>
                                        </td>
                                        <td >
                                            <p>شهركرد</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1119</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2002</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4240</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>26</p>
                                        </td>
                                        <td >
                                            <p>لردگان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>27</p>
                                        </td>
                                        <td >
                                            <p>بن</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>28</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>خراسان جنوبي</p>
                                        </td>
                                        <td >
                                            <p>بيرجند</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1105</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2067</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>3943</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>29</p>
                                        </td>
                                        <td >
                                            <p>نهبندان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>30</p>
                                        </td>
                                        <td >
                                            <p>طبس</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>31</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>خراسان رضوی</p>
                                        </td>
                                        <td >
                                            <p>قوچان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1098</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1819</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4092</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>32</p>
                                        </td>
                                        <td >
                                            <p>مشهد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>33</p>
                                        </td>
                                        <td >
                                            <p>جوين</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>34</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>خراسان شمالي</p>
                                        </td>
                                        <td >
                                            <p>اسفراين</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1100</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2000</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4075</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>35</p>
                                        </td>
                                        <td >
                                            <p>بجنورد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>36</p>
                                        </td>
                                        <td >
                                            <p>مانه وسملقان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>37</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>خوزستان</p>
                                        </td>
                                        <td >
                                            <p>اهواز</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1158</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2002</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4055</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>38</p>
                                        </td>
                                        <td >
                                            <p>بندرماهشهر</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>39</p>
                                        </td>
                                        <td >
                                            <p>هنديجان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>40</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>زنجان</p>
                                        </td>
                                        <td >
                                            <p>خدابنده</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1117</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2026</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4088</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>41</p>
                                        </td>
                                        <td >
                                            <p>زنجان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>42</p>
                                        </td>
                                        <td >
                                            <p>طارم</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>43</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>سمنان</p>
                                        </td>
                                        <td >
                                            <p>سمنان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1101</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2000</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4105</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>44</p>
                                        </td>
                                        <td >
                                            <p>شاهرود</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>45</p>
                                        </td>
                                        <td >
                                            <p>گرمسار</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>46</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>سيستان و بلوچستان</p>
                                        </td>
                                        <td >
                                            <p>زاهدان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1106</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2013</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4193</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>47</p>
                                        </td>
                                        <td >
                                            <p>خاش</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>48</p>
                                        </td>
                                        <td >
                                            <p>زابل</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>49</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>فارس</p>
                                        </td>
                                        <td >
                                            <p>شيراز</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1125</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1999</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4060</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>50</p>
                                        </td>
                                        <td >
                                            <p>لارستان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>51</p>
                                        </td>
                                        <td >
                                            <p>مرودشت</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>52</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>قزوين</p>
                                        </td>
                                        <td >
                                            <p>بوئين زهرا</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1116</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2000</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4089</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>53</p>
                                        </td>
                                        <td >
                                            <p>تاكستان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>54</p>
                                        </td>
                                        <td >
                                            <p>قزوين</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>55</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>کرمانشاه</p>
                                        </td>
                                        <td >
                                            <p>کرمانشاه</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1123</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1485</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4086</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>56</p>
                                        </td>
                                        <td >
                                            <p>گيلانغرب</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>57</p>
                                        </td>
                                        <td >
                                            <p>هرسين</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>58</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>كردستان</p>
                                        </td>
                                        <td >
                                            <p>بيجار</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1107</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1997</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4106</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>59</p>
                                        </td>
                                        <td >
                                            <p>سنندج</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>60</p>
                                        </td>
                                        <td >
                                            <p>قروه</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>61</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>كرمان</p>
                                        </td>
                                        <td >
                                            <p>بم</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1119</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2026</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4004</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>62</p>
                                        </td>
                                        <td >
                                            <p>رفسنجان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>63</p>
                                        </td>
                                        <td >
                                            <p>كرمان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>64</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>كهگيلويه بويراحمد</p>
                                        </td>
                                        <td >
                                            <p>بويراحمد</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1100</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1998</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4061</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>65</p>
                                        </td>
                                        <td >
                                            <p>كهگيلويه</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>66</p>
                                        </td>
                                        <td >
                                            <p>بهمئي</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>67</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>گلستان</p>
                                        </td>
                                        <td >
                                            <p>گرگان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1109</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1993</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4076</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>68</p>
                                        </td>
                                        <td >
                                            <p>كلاله</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>69</p>
                                        </td>
                                        <td >
                                            <p>آزادشهر</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>70</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>گيلان</p>
                                        </td>
                                        <td >
                                            <p>آستانه اشرفيه</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1100</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1998</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4036</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>71</p>
                                        </td>
                                        <td >
                                            <p>رشت</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>72</p>
                                        </td>
                                        <td >
                                            <p>رودبار</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>73</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>لرستان</p>
                                        </td>
                                        <td >
                                            <p>اليگودرز</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1072</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2000</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4075</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>74</p>
                                        </td>
                                        <td >
                                            <p>بروجرد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>75</p>
                                        </td>
                                        <td >
                                            <p>خرم آباد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>76</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>مازندران</p>
                                        </td>
                                        <td >
                                            <p>رامسر</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1102</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2010</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4060</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>77</p>
                                        </td>
                                        <td >
                                            <p>ساری</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>78</p>
                                        </td>
                                        <td >
                                            <p>نكا</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>79</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>مرکزي</p>
                                        </td>
                                        <td >
                                            <p>اراک</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1109</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1993</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4061</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>80</p>
                                        </td>
                                        <td >
                                            <p>شازند</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>81</p>
                                        </td>
                                        <td >
                                            <p>کميجان</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>82</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>هرمزگان</p>
                                        </td>
                                        <td >
                                            <p>بندرعباس</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1102</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2000</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>3661</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>83</p>
                                        </td>
                                        <td >
                                            <p>بندرلنگه</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>84</p>
                                        </td>
                                        <td >
                                            <p>خمير</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>85</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>همدان</p>
                                        </td>
                                        <td >
                                            <p>همدان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1107</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1995</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>3708</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>86</p>
                                        </td>
                                        <td >
                                            <p>كبودرآهنگ</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>87</p>
                                        </td>
                                        <td >
                                            <p>اسدآباد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>88</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>يزد</p>
                                        </td>
                                        <td >
                                            <p>اردكان</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>1100</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>2005</p>
                                        </td>
                                        <td rowspan="3" >
                                            <p>4048</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>89</p>
                                        </td>
                                        <td >
                                            <p>تفت</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>90</p>
                                        </td>
                                        <td >
                                            <p>يزد</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <p>91</p>
                                        </td>
                                        <td >
                                            <p>قم</p>
                                        </td>
                                        <td >
                                            <p>قم</p>
                                        </td>
                                        <td >
                                            <p>1104</p>
                                        </td>
                                        <td >
                                            <p>2040</p>
                                        </td>
                                        <td >
                                            <p>3995</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>&nbsp;</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default AboutSurvey;